<div>
    <p-table [value]="despesas" [lazy]="true" (onLazyLoad)="loadDespesas($event)" [paginator]="true" [rows]="rows" [first]="first" [totalRecords]="totalRecords" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="empresa">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
            <th pSortableColumn="filial">Filial <p-sortIcon field="filial"></p-sortIcon></th>
            <th pSortableColumn="dataReferencia">Data Referência <p-sortIcon field="dataReferencia"></p-sortIcon></th>
            <th pSortableColumn="centroCusto">Centro de Custo <p-sortIcon field="centroCusto"></p-sortIcon></th>
            <th pSortableColumn="contaContabil">Conta Contábil <p-sortIcon field="contaContabil"></p-sortIcon></th>
            <th pSortableColumn="valorTotal">Valor Total <p-sortIcon field="valorTotal"></p-sortIcon></th>
            <th pSortableColumn="dataRecebimento">Data Recebido <p-sortIcon field="dataRecebimento"></p-sortIcon></th>
            <th pSortableColumn="statusIntegracao">Status Integração <p-sortIcon field="statusIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataIntegracao">Data Integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
            <th pSortableColumn="mensagemIntegracao">Mensagem Integração <p-sortIcon field="mensagemIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataUltimaAtualizacao">Data Última Atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-despesa>
          <tr>
            <td>{{ despesa.empresa }}</td>
            <td>{{ despesa.filial }}</td>
            <td>{{ despesa.dataReferencia }}</td>
            <td>{{ despesa.centroCusto }}</td>
            <td>{{ despesa.contaContabil }}</td>
            <td>{{ despesa.valorTotal.toLocaleString("pt-BR") }}</td>
            <td>{{ despesa.dataRecebimento }}</td>
            <td><app-tag-status [status]="despesa.statusIntegracao"></app-tag-status></td>
            <td>{{ despesa.dataIntegracao }}</td>
            <td>{{ despesa.mensagemIntegracao }}</td>
            <td>{{ despesa.dataUltimaAtualizacao }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
      </ng-template>
      </p-table>
</div>
